<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'item_type_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    [componentName]="'item-types'"
    layout-center-header
    (add)="openCreateItemTypeDialog()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-list
    [contextMenuActions]="itemTypesContextMenuActions"
    [disableContextActions]="anyLoading$ | async"
    [isReadOnly]="isReadOnly$ | async"
    [items]="itemTypesAsGenericItems$ | async"
    layout-center-content
    (onSelectItem)="onSelectItemType($event)"
  ></emm-generic-items-list>
  @if (itemDetail$ | async; as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
    ></emm-management-attributes-header>
  }
  <emm-item-types-form
    #form
    layout-right-content
    [isSuperAdmin]="isSuperAdmin"
    [isAdmin]="isAdmin"
  ></emm-item-types-form>
  @if ((itemDetail$ | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!itemTypesForm || !itemTypesForm.isFormReady()"
      [disableUpdate]="!itemTypesForm || !itemTypesForm.hasChanges()"
      layout-right-footer
      (cancel)="itemTypesForm.cancel()"
      (submit)="submitForm()"
      class="item-types-footer"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
